// HeroSection.jsx
import './heroSection.css';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';


const HeroSection = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isPlaying, setIsPlaying] = useState(true);
  const videoRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const togglePlay = () => {
    if (!videoRef.current) return;
    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  const enterFullScreen = () => {
    if (videoRef.current.requestFullscreen) {
      videoRef.current.requestFullscreen();
    } else if (videoRef.current.webkitRequestFullscreen) {
      videoRef.current.webkitRequestFullscreen();
    } else if (videoRef.current.msRequestFullscreen) {
      videoRef.current.msRequestFullscreen();
    }
  };

  const navigate = useNavigate();
  return (
    <div className="hero-container">
      <div className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="navbar-left">
          <div className={`title-wrapper ${scrolled ? 'scrolled' : ''}`}>
            {!scrolled && (
              <div className="initial-buttons">
                <button className="project-btn" onClick={() => navigate('/projects')}>
                  Projects
                </button>
                <button className="contact-btn">Contact Us <ArrowOutwardIcon className="icon" /></button>
              </div>
            )}

            {/* Hamburger Icon for Mobile */}
            {!scrolled && (
              <div className="hamburger-icon" onClick={() => setMenuOpen(!menuOpen)}>
                {menuOpen ? <CloseIcon /> : <MenuIcon />}
              </div>
            )}

            {/* Mobile Dropdown Menu */}
            {/* {menuOpen && (
              <div className="mobile-menu">
                <button className="project-btn" onClick={() => { navigate('/projects'); setMenuOpen(false); }}>
                  Projects
                </button>
                <button className="contact-btn" onClick={() => { setMenuOpen(false); }}>
                  Contact Us <ArrowOutwardIcon className="icon" />
                </button>
              </div>
            )} */}


            <img src="/images/Saffron_House.png" alt="Saffron House" className="main-logo" />
            <p className="tagline">Tailored interior designs to reflect your personality</p>
          </div>
        </div>

        {scrolled && (
          <div className="navbar-buttons">
            <button className="project-btn" onClick={() => navigate('/projects')}>
              Projects
            </button>
            <button className="contact-btn">Contact Us <ArrowOutwardIcon className="icon" /></button>
          </div>
        )}

        {scrolled && (
          <div className="hamburger-icon" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <CloseIcon /> : <MenuIcon />}
          </div>
        )}
      </div>

      <div className="hero-image" onClick={enterFullScreen}>
        <div className="video-wrapper">
          <video
            ref={videoRef}
            autoPlay
            loop
            muted
            playsInline
            className="hero-video"
          >
            <source src="/images/Hero_Video.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          {/* <button className="video-control" onClick={(e) => {
            e.stopPropagation(); // prevent triggering full screen
            togglePlay();
          }}>
            {isPlaying ? '||' : '►'}
          </button> */}
        </div>
      </div>
      {menuOpen && (
        <div className="mobile-menu">
          <button className="project-btn" onClick={() => { navigate('/projects'); setMenuOpen(false); }}>
            Projects
          </button>
          <button className="contact-btn" onClick={() => { setMenuOpen(false); }}>
            Contact Us <ArrowOutwardIcon className="icon" />
          </button>
        </div>
      )}
    </div>
  );
};

export default HeroSection;

// import './heroSection.css';
// import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
// import React, { useEffect, useState, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import MenuIcon from '@mui/icons-material/Menu';
// import CloseIcon from '@mui/icons-material/Close';

// const HeroSection = () => {
//   const [scrolled, setScrolled] = useState(false);
//   const [isPlaying, setIsPlaying] = useState(true);
//   const [menuOpen, setMenuOpen] = useState(false);
//   const videoRef = useRef(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 100);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const togglePlay = () => {
//     if (!videoRef.current) return;
//     if (videoRef.current.paused) {
//       videoRef.current.play();
//       setIsPlaying(true);
//     } else {
//       videoRef.current.pause();
//       setIsPlaying(false);
//     }
//   };

//   const enterFullScreen = () => {
//     if (!videoRef.current) return;
//     const video = videoRef.current;
//     if (video.requestFullscreen) {
//       video.requestFullscreen();
//     } else if (video.webkitRequestFullscreen) {
//       video.webkitRequestFullscreen();
//     } else if (video.msRequestFullscreen) {
//       video.msRequestFullscreen();
//     }
//   };

//   return (
//     <div className="hero-container">
//       <div className={`navbar ${scrolled ? 'scrolled' : ''}`}>
//         <div className="navbar-inner">
//           <div className="navbar-left">
//             <div className={`title-wrapper ${scrolled ? 'scrolled' : ''}`}>
//               <img src="/images/Saffron_House.png" alt="Saffron House" className="main-logo" />
//               <p className="tagline">Tailored interior designs to reflect your personality</p>
//             </div>
//           </div>

//           {scrolled && (
//             <>
//               <div className="navbar-buttons">
//                 <button className="project-btn" onClick={() => navigate('/projects')}>Projects</button>
//                 <button className="contact-btn">Contact Us <ArrowOutwardIcon className="icon" /></button>
//               </div>

//               <div className="hamburger-icon" onClick={() => setMenuOpen(!menuOpen)}>
//                 {menuOpen ? <CloseIcon /> : <MenuIcon />}
//               </div>
//             </>
//           )}

//           {!scrolled && (
//             <div className="initial-buttons">
//               <button className="project-btn" onClick={() => navigate('/projects')}>Projects</button>
//               <button className="contact-btn">Contact Us <ArrowOutwardIcon className="icon" /></button>
//               <div className="hamburger-icon" onClick={() => setMenuOpen(!menuOpen)}>
//                 {menuOpen ? <CloseIcon /> : <MenuIcon />}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       <div className="hero-image" onClick={enterFullScreen}>
//         <div className="video-wrapper">
//           <video
//             ref={videoRef}
//             autoPlay
//             loop
//             muted
//             playsInline
//             className="hero-video"
//           >
//             <source src="/images/Hero_Video.mp4" type="video/mp4" />
//             Your browser does not support the video tag.
//           </video>

//           <button
//             className="video-control"
//             onClick={(e) => {
//               e.stopPropagation();
//               togglePlay();
//             }}
//           >
//             {isPlaying ? '||' : '►'}
//           </button>
//         </div>
//       </div>

//       {menuOpen && (
//         <div className="mobile-menu">
//           <button className="project-btn" onClick={() => { navigate('/projects'); setMenuOpen(false); }}>
//             Projects
//           </button>
//           <button className="contact-btn" onClick={() => setMenuOpen(false)}>
//             Contact Us <ArrowOutwardIcon className="icon" />
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default HeroSection;

